// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".unlockable-container[data-v-04ff8df5]{max-width:60%;border-radius:2rem}.light-mode .unlockable-container[data-v-04ff8df5]{border-color:#ccc}.dark-mode .unlockable-container[data-v-04ff8df5]{border-color:#999}@media screen and (max-width:1215px){.unlockable-container[data-v-04ff8df5]{max-width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
